import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavTag } from '~/shared-components';
import { getURL } from '~/server/formatters';
import { BufferTracker } from '@bufferapp/buffer-tracking-browser-ts';
import { useAccount } from '~/accountContext';

import {
  CircleIcon,
  SidebarItem,
  ListItemContainer,
  StyledAddIcon,
} from './style';

const AddChannelButton = ({ label, reachedChannelLimit }) => {
  const { account } = useAccount();
  const billing = account?.currentOrganization?.billing;
  const commonTrackingProperties =
    account?.currentOrganization?.commonTrackingProperties || null;

  const handleAddChannelClick = () => {
    BufferTracker.sidebarAddChannelClicked({
      organizationId: account?.currentOrganization?.id,
      currentChannelQuantity:
        account?.currentOrganization?.channels?.length || 0,
      isAtPlanLimit: reachedChannelLimit || null,
      atEventBillingState:
        commonTrackingProperties?.atEventBillingState || null,
      atEventBillingPlan: commonTrackingProperties?.atEventBillingPlan || null,
      atEventBillingCycle:
        commonTrackingProperties?.atEventBillingCycle || null,
      atEventBillingGateway:
        commonTrackingProperties?.atEventBillingGateway || null,
      atEventIsNewBuffer: commonTrackingProperties?.atEventIsNewBuffer || null,
      atEventChannelQty: commonTrackingProperties?.atEventChannelQty || null,
      hasPaymentDetails: billing?.paymentDetails?.hasPaymentDetails || null,
    });

    BufferTracker.ctaClicked({
      organizationId: account?.currentOrganization?.id || '',
      ctaName: `add-channel-sidebar-${
        reachedChannelLimit ? 'atlimit' : 'prelimit'
      }`,
      cta: `add-channel-sidebar-${
        reachedChannelLimit ? 'atlimit' : 'prelimit'
      }`,
      upgradePathName: 'addChannel-upgrade',
      product: 'publish',
      clientName: 'publishWeb',
      ...commonTrackingProperties,
    });

    window.location.assign(getURL.getChannelConnectURL());
  };

  useEffect(() => {
    if (reachedChannelLimit) {
      BufferTracker.ctaViewed({
        organizationId: account?.currentOrganization?.id || null,
        ctaName: 'add-channel-sidebar-atlimit',
        currentChannelQuantity:
          account?.currentOrganization?.channels?.length || 0,
        isAtPlanLimit: true,
        product: 'publish',
        upgradePathName: 'addChannel-upgrade',
        ...commonTrackingProperties,
      });
    }
  }, [
    account?.currentOrganization,
    reachedChannelLimit,
    commonTrackingProperties,
  ]);

  return (
    <ListItemContainer>
      <SidebarItem
        title={label}
        onItemClick={() => handleAddChannelClick()}
        /* eslint-disable no-nested-ternary */
        badges={reachedChannelLimit && <NavTag type="paywall" />}
        icon={
          <CircleIcon>
            <StyledAddIcon />
          </CircleIcon>
        }
        /* eslint-enable no-nested-ternary */
      />
    </ListItemContainer>
  );
};

AddChannelButton.propTypes = {
  label: PropTypes.string,
  reachedChannelLimit: PropTypes.bool,
};

AddChannelButton.defaultProps = {
  label: 'Add Channels',
  reachedChannelLimit: true,
};

export default AddChannelButton;
